import React, { Component } from "react";
import * as Icon from "react-feather";

const SYSTEM_FOLDERS = [
	{ key: "inbox", label: "Inbox", icon: Icon.Inbox },
	{ key: "starred", label: "Starred", icon: Icon.Star },
	{ key: "sent", label: "Sent", icon: Icon.Send },
	{ key: "drafts", label: "Drafts", icon: Icon.FileText },
	{ key: "important", label: "Important", icon: Icon.AlertCircle },
	{ key: "spam", label: "Spam", icon: Icon.Slash },
	{ key: "trash", label: "Trash", icon: Icon.Trash2 },
	{ key: "all", label: "All Mail", icon: Icon.Archive },
];

class InboxSidebar extends Component {
	onChangeAccount = e => {
		const accountId = parseInt(e.target.value, 10);
		if (this.props.onSelectAccount) this.props.onSelectAccount(accountId);
	};

	render() {
		const { accounts, currentAccountId, currentFolder, labels = [], onSelectFolder, onCompose } = this.props;

		return (
			<div className="inbox-sidebar">
				<div className="inbox-sidebar__account">
					<div className="inbox-sidebar__account-label">Mailbox</div>
					<select className="inbox-sidebar__account-selector" value={currentAccountId || ""} onChange={this.onChangeAccount}>
						{accounts.map(a => (
							<option key={a.id} value={a.id}>
								{a.email_address}
							</option>
						))}
					</select>
				</div>

				{onCompose && (
					<div className="inbox-sidebar__compose-wrap">
						<button className="inbox-sidebar__compose" onClick={onCompose}>
							<Icon.Edit3 size={16} /> Compose
						</button>
					</div>
				)}

				<div className="inbox-sidebar__section-title">Folders</div>
				<div className="inbox-sidebar__list">
					{SYSTEM_FOLDERS.map(f => {
						const IconCmp = f.icon;
						const active = currentFolder === f.key;
						return (
							<div
								key={f.key}
								className={`inbox-folder${active ? " is-active" : ""}`}
								onClick={() => onSelectFolder && onSelectFolder(f.key)}
							>
								<IconCmp size={16} className="inbox-folder__icon" />
								<span className="inbox-folder__label">{f.label}</span>
							</div>
						);
					})}
				</div>

				{labels && labels.length > 0 && (
					<>
						<div className="inbox-sidebar__section-title">Labels</div>
						<div className="inbox-sidebar__list">
							{labels.map(l => {
								const active = currentFolder === l.id;
								return (
									<div
										key={l.id}
										className={`inbox-folder${active ? " is-active" : ""}`}
										onClick={() => onSelectFolder && onSelectFolder(l.id)}
										title={l.name}
									>
										<Icon.Tag size={16} className="inbox-folder__icon" />
										<span className="inbox-folder__label">{l.name}</span>
									</div>
								);
							})}
						</div>
					</>
				)}
			</div>
		);
	}
}

export default InboxSidebar;
